import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';

const VINYL_CATS = {
  '1': '0000000000000000000010',
  '2': '00000000000000000000000010',
  '3': '0000000000000000000000010',
  '6': '0000000000000000000010',
};

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: true
})
export class PageNotFoundComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  constructor(
    private router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        const url = this.router.url.toLocaleLowerCase();
        if (url.indexOf('vinyl') >= 0) {
          let domain: keyof typeof VINYL_CATS = '1';
          if (url.indexOf('vinyl/uk') >= 0) {
            domain = '2';
          } else if (url.indexOf('vinyl/de') >= 0) {
            domain = '3';
          } else if (url.indexOf('vinyl/ca') >= 0) {
            domain = '6';
          }
          this.router.navigate(['/deals'], {
            queryParams: { domain: domain, cat: VINYL_CATS[domain] },
          });
        }
      });
  }
}
